import "core-js/modules/es6.object.assign.js";
import Notify from 'quasar/src/plugins/Notify.js';;

var defaultState = function defaultState() {
  return {
    toasts: []
  };
};

var state = defaultState();
var getters = {};
var mutations = {
  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },
  setToast: function setToast(state, toast) {
    state.toasts = state.toasts.concat(toast);
  }
};
var actions = {
  /**
   * Create a toast message
   * @param {Object} context Vuex module context
   * @param {Array} payload.actions The toast message actions.
   * @param {String} payload.caption The toast message caption.
   * @param {String} payload.type The toast message type.
   * @param {String} payload.message The toast message content.
   * @param {String} payload.position Position for the toast message. Defaults to top.
   * @param {Number} payload.timeout Time in milliseconds to show the toast message for. Pass 0 for an infinite timeout. Defaults to 3 seconds.
   * @param {Boolean} payload.html Permit HTML. Defaults to false.
   * @returns {Void}
   */
  toast: function toast(context, payload) {
    var _payload$timeout, _payload$html;

    Notify.create({
      actions: payload.actions || [{
        color: 'white',
        icon: 'close'
      }],
      caption: payload.caption,
      classes: payload.type,
      icon: payload.type === 'error' ? 'warning' : payload.type === 'success' ? 'check' : false,
      message: payload.message,
      position: payload.position || 'top',
      // Default to a 3 second timeout, but be careful to use ?? instead of ||, as a value of 0
      // may be passed to indicate an infinite timeout.
      timeout: (_payload$timeout = payload.timeout) !== null && _payload$timeout !== void 0 ? _payload$timeout : 3000,
      type: payload.type,
      html: (_payload$html = payload === null || payload === void 0 ? void 0 : payload.html) !== null && _payload$html !== void 0 ? _payload$html : false
    });
    context.commit('setToast', payload);
  }
};
export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
};